import styled from "styled-components";

interface StyledAnonymousProps {
  $isVisible: boolean;
}

export const StyledAnonymous = styled.div<StyledAnonymousProps>`
  opacity: ${(props) => (props.$isVisible ? 1 : 0)};
  transform: ${(props) =>
    props.$isVisible ? "translateY(0)" : "translateY(20px)"};
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;

  .anonymous-container {
    padding: 0 25px;
  }
`;

